export default __webpack_public_path__ + "static/media/marker.f5c2f15d.svg";